// let httpUser = `http://user-api-dev.996box.com` // 用户
// let httpContent = `http://pc-content-dev.dhsf.xqhuyu.com` // 内容
// let httpLiveBroad = `http://live-dev.996box.com`  // 直播
// let httpCompetition = `http://boxmanagerht-api-dev.dhsf.xqhuyu.com/uploads`  // 赛事
// ------------------正式----------------------
// let httpUser = `https://user-api.996box.com` // 用户
// let httpContent = `https://pc-api.996box.com` // 内容
// let httpLiveBroad = `https://live-api.996box.com`  // 直播
// let httpCompetition = `https://tgdata.996box.com` // 内容

const httpUser = process.env.VUE_APP_USER_BASE_URL; // 用户
const httpContent = process.env.VUE_APP_PC_BASE_URL; // 内容
const httpLiveBroad = process.env.VUE_APP_LIVE_BASE_URL; // 直播
let httpCompetition = process.env.VUE_APP_BOXMANAGE_BASE_URL; // 内容
const httpForum = process.env.VUE_APP_FORUM_BASE_URL; // 内容
const httpCollect = process.env.VUE_APP_COLLECT_BASE_URL; // 埋点收集
const httpJava = process.env.VUE_APP_JAVA_URL; // java接口
const boxCollectApi = process.env.VUE_APP_BOXCOLLECT_BASE_URL; // 盒子新统一埋点收集
let baiduApi = `//pc-api.996box.com/v2/homeapi/Ocpcapi/index`;

const firstVersoin = `/v1`; // 第一版
const secondVersoin = `/v2`; // 第一版
const homeUrl = `/homeapi`; // 首页
const OperationUrl = `/Operation`; // 埋点
const liveBroadApi = `/api`;
// 是否为开发环境
if (process.env.NODE_ENV === "development") {
  // httpUser = ``; // 用户
  // httpContent = ``; // 内容
  // httpLiveBroad = ``;
  // liveBroadApi = `/liveApi`;
  httpCompetition = `/uploads`;
  baiduApi = `http://pc-content-dev.dhsf.xqhuyu.com/v2/homeapi/Ocpcapi/index`;
}
export default {
  homes: {
    // 获取下载链接
    getGameLink: `https://tgdata.996box.com/down_url.json`,
    // 获取盒子下载链接
    getDownUrl: `${httpUser}${firstVersoin}/ChannelDownLink/getDownUrl`,
    // 获取QQ一键加群KEY
    getQQKey: `${httpContent}${firstVersoin}${homeUrl}/Homeindex/randomQqQunKey`,
    // 顶部轮播和排行版
    homeList: `${httpContent}${firstVersoin}${homeUrl}/homeindex/info`,
    // 排行榜java
    allRankGames: `${httpJava}/box/v1/allRankGames`,
    // 获取排行榜游戏
    withRankJava: `${httpContent}/v1/homeapi/FindGame/getGameListWithRank`,
    // 新闻列表
    getNewsList: `${httpContent}${firstVersoin}${homeUrl}/Homeindex/getNewsList`,
    // 获取新闻详情
    getNewsInfo: `${httpContent}${firstVersoin}${homeUrl}/Homeindex/getNewsInfo`,
    // 游戏详情
    gameInfo: `${httpContent}${firstVersoin}${homeUrl}/gameindex/gameInfo`,
    // 同厂推荐
    firmRecommend: `${httpContent}${firstVersoin}${homeUrl}/gameindex/firmRecommend`,
    // 新游推荐
    newGameList: `${httpContent}${firstVersoin}${homeUrl}/Gameindex/NewGameList`,
    // 版本与标签接口
    tagList: `${httpContent}${firstVersoin}${homeUrl}/FindGame/getAllVersionAndTagList`,
    // 版本与标签接口
    getAllVersionAndTagList: `${httpContent}/v2/homeapi/ShunWan/getAllVersionAndTagList`,
    // shunwan渠道开服列表
    getListShunWan: `${httpContent}/v2/homeapi/ShunWan/getList`,
    // 时间段配置获取
    getTimeSection: `${httpContent}/v2/homeapi/ShunWan/getTimeSection`,
    // 游戏热搜数据
    hot_search: `/userApi/v1/Essearch/hot_search`,
    // 搜索框提示词   模糊查询
    query_prefix: `/userApi/v1/Essearch/query_prefix`,
    // 搜索框随机提示词
    getCueWord: `/userApi/v1/Essearch/randomCueWord`,
    // 游戏搜索页
    es_search: `/userApi/v1/Essearch/es_search`,
    // 清空历史记录
    del_history: `/userApi/v1/Essearch/del_history`,
    // 删除单条历史记录
    del_single_history: `/userApi/v1/Essearch/del_single_history`,
    // 获取ios下载key
    getIosAppKey: `${httpUser}${firstVersoin}/ChannelDownLink/getBoxIosDownurl`,
    // 游戏详情java
    getGameInfo: `${httpJava}/box/v1/getGameInfo`,
    // bing搜索游戏点击下载java -- 白金泽
    clickBing: `${httpJava}/trilateral/bing/clickBing`,
    // 获取ios下载链接
    iosDownloadClick: `${httpUser}${firstVersoin}/ChannelDownLink/iosDownloadClick`,
    // 优酷上报第三方调用数据检测 -- 白金泽
    monitor: `${httpJava}/trilateral/youKu/monitor`,
    // 搜狗PC端注册上报 -- 白金泽
    sougouMonitor: `${httpJava}/trilateral/sougou/monitor`,
  },
  // 埋点
  operation: {
    // 操作记录
    record: `${httpUser}${firstVersoin}${OperationUrl}/record`,
    // 用户行为记录
    footprint: `${httpUser}${firstVersoin}${OperationUrl}/footprint`,
  },
  // 直播
  live: {
    // 禁言用户列表
    muteUserList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/muteUserList`,
    // 查询用户
    searchUser: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/searchUser`,
    // 解除禁言记录列表
    unlockMuteList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/unlockMuteList`,
    // 解除禁言
    unlockMute: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/unlockMute`,
    // 禁言观众/添加
    muteUser: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/muteUser`,
    // 屏蔽词列表
    blackWordsList: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/blackWordsList`,
    // 删除屏蔽词
    delBlackWord: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/delBlackWord`,
    // 添加直播间屏蔽词
    addBlackWord: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/addBlackWord`,
    // 收礼列表
    receivedGiftList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/Gift/receivedGiftList`,
    // 关注/取关
    doFollow: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/doFollow`,
    // 直播列表
    liveList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/live/liveList`,
  },
  liveBroadRoom: {
    // 推荐直播
    recommendLiveList: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/recommendLiveList`,
    // 获取拉流地址
    getPullUrl: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/getPullUrl`,
    // 直播列表
    liveList: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/liveList`,
    // 礼物列表
    giftList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/Gift/giftList`,
    //  主播中心设置
    anchorCenter: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/User/anchorCenter`,
    //  主播中心设置保存
    anchorCenterSave: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/User/anchorCenterSave`,
    //  开始直播
    beginLive: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/beginLive`,
    //  结束直播
    endLive: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/endLive`,
    //  直播记录
    liveRecord: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/liveRecord`,
    //  获取推流地址（CDN推拉流）
    getPushKey: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/getPushKey`,
    //  直播间详情
    liveDetail: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/liveDetail`,
    //  观众进入直播间
    enterLiveRoom: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/enterLiveRoom`,
    //  文本消息-发送文本消息
    sendTextMessage: `http://live-dev.996box.com/api/v2/Message/sendTextMessage`,
    //  赠送礼物
    giveGift: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/Gift/give`,
    //  关闭推流地址显示(CDN推拉流)
    closePushUrl: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/closePushUrl`,
    // 关注列表
    followList: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/user/followList`,
    //  结束界面直播推荐(CDN推拉流)
    recommendLive: `${httpLiveBroad}${liveBroadApi}${firstVersoin}/Live/recommendLive`,
    //  主播中心标题保存
    anchorCenterSaveTitle: `${httpLiveBroad}${liveBroadApi}${secondVersoin}/User/anchorCenterSaveTitle`,
    //  观众退出直播间
    quitLiveRoom: `/liveApi/api/v3/Room/quitRoom`,
  },
  // 赛事
  competition: {
    //  赛程预告
    competition_time: `${httpCompetition}/competition/competition_time.json`,
    //  参赛资格
    config: `${httpCompetition}/competition/config.json`,
    //  参赛介绍
    family: `${httpCompetition}/competition/family.json`,
    //  小组赛
    group: `${httpCompetition}/competition/group.json`,
    //  淘汰赛
    eliminate: `${httpCompetition}/competition/eliminate.json`,
    //  排名
    rank: `${httpCompetition}/competition/rank.json`,
  },
  sw: {
    uploadConvertData: baiduApi,
  },
  competitionEvent: {
    //  赛事推荐banner列表 -- 刘琪
    recommandBanner: `${httpContent}/v1/homeapi/Match/recommandBanner`,
    // 专区banner列表 -- 刘琪
    areaBanner: `${httpContent}/v1/homeapi/Match/areaBanner`,
    // 专区列表 -- 刘琪
    areaList: `${httpContent}/v1/homeapi/Match/areaList`,
    // 资讯分类列表 -- 刘琪
    infoAssortList: `${httpContent}/v1/homeapi/Match/infoAssortList`,
    // 获取资讯 -- 刘琪
    getInfo: `${httpContent}/v1/homeapi/Match/getInfo`,
    // 赛事日历接口 -- 贾琳
    matchCalendar: `${httpContent}/v1/homeapi/Match/matchCalendar`,
    // 赛事日历列表接口 -- 贾琳
    matchCalendarList: `${httpContent}/v1/homeapi/Match/matchCalendarList`,
    // 推荐日历赛事接口 -- 贾琳
    MatchArea: `${httpContent}/v1/homeapi/Match/MatchArea`,
    // 专区概述接口 -- 贾琳
    matchAreaSummary: `${httpContent}/v1/homeapi/Match/matchAreaSummary`,
    // 推荐日历赛事接口 -- 贾琳
    matchArea: `${httpContent}/v1/homeapi/Match/MatchArea`,
    // 增加观看次数 -- 贾琳
    playTimes: `${httpContent}/v1/homeapi/Match/playTimes`,
    // 赛事资讯 -- 刘琪
    matchInfo: `${httpContent}/v1/homeapi/Match/matchInfo`,
    // 登录游戏接口 -- 贾琳
    matchAreaGame: `${httpContent}/v1/homeapi/Match/matchAreaGame`,
    // 专区赛事概述标题 -- 贾琳
    matchOutsTitle: `${httpContent}/v1/homeapi/Match/matchOutsTitle`,
    // 赛况概述接口 -- 贾琳
    matchOuts: `${httpContent}/v1/homeapi/Match/matchOuts`,
    // 专区背景图 -- 贾琳
    matchAreaBackground: `${httpContent}/v1/homeapi/Match/matchAreaBackground`,
  },
  commonity: {
    // 社区首页
    getCommunityList: `${httpForum}/v1/Community/getCommunityList`,
    // 获取社区子模块和分类
    pcCommunityHome: `${httpForum}/v1/Community/pcCommunityHome`,
    // 获取栏目帖子列表、置顶帖子
    getPostByCategory: `${httpForum}/v1/Post/getPostByCategory`,
    // 获取社区页面栏目
    getPostNavBar: `${httpForum}/v1/Category/getPostNavBar`,
    // 删除帖子
    deletePost: `${httpForum}/v1/Post/deletePost`,
    // 点赞/取消点赞
    doUpvote: `${httpForum}/v1/Upvote/doUpvote`,
    // 分享后回调
    doShare: `${httpForum}/v1/Share/doShare`,
    // 获取发帖选择栏目
    getPostCategory: `${httpForum}/v1/Category/getPostCategory`,
    // 图片上传
    uploadImg: `${httpForum}/v1/Post/uploadImg`,
    // 视频上传
    uploadVideo: `${httpForum}/v1/Post/uploadVideo`,
    // 发布帖子
    publishPost: `${httpForum}/v1/Post/publishPost`,
    // 编辑帖子 ----- 刘阳
    modifyPost: `${httpForum}/v1/Post/modifyPost`,
    // 帖子详情
    postDetail: `${httpForum}/v1/Post/postDetail`,
    // 收藏/取消收藏
    doCollect: `${httpForum}/v1/Collect/doCollect`,
    // 关注列表
    follows: `${httpForum}/v1/User/follows`,
    // 关注/取消关注
    doFollow: `${httpForum}/v1/User/doFollow`,
    // 粉丝列表
    fans: `${httpForum}/v1/User/fans`,
    // 我的/他人帖子列表
    getUserPost: `${httpForum}/v1/Post/getUserPost`,
    // 回复帖子列表
    getReplyPosts: `${httpForum}/v1/Post/getReplyPosts`,
    // 用户详情
    detail: `${httpForum}/v1/User/detail`,
    // 我的/他人收藏列表
    collectionList: `${httpForum}/v1/Collect/collectionList`,
    // 获取一级评论
    getComment: `${httpForum}/v1/Comment/getComment`,
    // 获取二级评论
    getChildComment: `${httpForum}/v1/Comment/getChildComment`,
    // 发表评论
    doComment: `${httpForum}/v1/Comment/doComment`,
    // 发表评论（新） ----- 刘阳
    doCommentNew: `${httpForum}/v1/Comment/doCommentNew`,
    // 用户信用分 ----- 刘阳
    getCredit: `${httpForum}/v1/User/getCredit`,
    // 删除评论 ----- 刘阳
    deleteComment: `${httpForum}/v1/Comment/deleteComment`,
    // 帖子热评 ----- 刘阳
    getHotComment: `${httpForum}/v1/Comment/getHotComment`,
    // Banner列表 ----- 刘阳
    getBannerList: `${httpForum}/v1/Banner/getList`,
    // 创作者激励页面 ----- 刘阳
    creatorRewardPage: `${httpForum}/v1/Banner/creatorRewardPage`,
    // 创作者榜单 ----- 刘阳
    creatorRankPage: `${httpForum}/v1/Banner/creatorRankPage`,
    // 话题 ----- 刘阳
    // 发现话题
    homeList: `${httpForum}/v1/topic/homeList`,
    // 帖子广场
    topicSquare: `${httpForum}/v1/topic/topicSquare`,
    // 话题详情
    topicDetail: `${httpForum}/v1/topic/detail`,
    // 发现话题
    getTopicPosts: `${httpForum}/v1/topic/getTopicPosts`,
  },
  game: {
    // 全部游戏
    myGames: `${httpContent}/v1/homeapi/gameindex/myGames`,
    // 删除游戏
    delLatelyGame: `${httpContent}/v1/homeapi/gameindex/delLatelyGame`,
    // 游戏详情
    gameInfo: `${httpContent}/v1/homeapi/gameindex/gameInfo`,
    // 游戏礼包
    gameGift: `${httpContent}/v2/homeapi/FindGame/gift`,
    // 游戏礼包码
    getGameGiftCode: `${httpContent}/v1/homeapi/Gameindex/getGameGiftCode`,
    // 同厂推荐
    firmRecommend: `${httpContent}/v1/homeapi/gameindex/firmRecommend`,
    // 直接启动游戏
    EnterGame: `${httpContent}/v1/homeapi/gameindex/EnterGame`,
    // 启动游戏登录器
    EnterGameClient: `${httpContent}/v1/homeapi/gameindex/EnterGameClient`,
    // 角色试玩登录游戏
    demoaccountlogin: `${httpContent}/v1/homeapi/Gameindex/demoaccountlogin`,
    // 批量获取游戏信息 ----- 刘阳
    getGamesInfo: `${httpForum}/v1/Game/getGamesInfo`,
    // 直播埋点-记录启动游戏场景
    recordEnterGameScene: `${httpContent}/v1/homeapi/Gameindex/recordEnterGameScene`,
  },
  // java接口
  gameJava: {
    // 开服列表
    gameOpenList: `${httpJava}/box/v1/todayGames`,
  },
  collection: {
    collect: `${httpCollect}`,
    competitionCollect: `/competitionCollet/api/collect/collect`,
    boxCollect: `${boxCollectApi}/v1/newLog`,
  },
};
